import { Link, useLocation } from "react-router-dom";
import AuthStore from "../../stores/AuthStore";
import { observer } from "mobx-react";
import { Button } from "../ui/button";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "../ui/navigation-menu";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { Logo } from "../brand/logo";
import { LanguageSwitcher } from "../language-switcher";

export const NavbarLandingPage = observer(() => {
  const { t } = useTranslation();
  const location = useLocation();

  const navItems = [
    { name: t("home"), path: "/" },
    { name: t("about"), path: "/about" },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center">
            <Logo size={30} />
          </Link>

          <NavigationMenu className="hidden md:flex">
            <NavigationMenuList>
              {navItems.map((item) => (
                <NavigationMenuItem key={item.path}>
                  <NavigationMenuLink asChild>
                    <Link
                      to={item.path}
                      className={cn(
                        navigationMenuTriggerStyle(),
                        location.pathname === item.path && "bg-accent text-accent-foreground"
                      )}
                    >
                      {item.name}
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
          </NavigationMenu>

          <div className="flex items-center gap-2 sm:gap-4">
            <LanguageSwitcher />
            {AuthStore.isLogin || AuthStore.isHaveTokenLogin() ? (
              <Button asChild variant="default">
                <Link to="/dashboard">{t("goToDashboard")}</Link>
              </Button>
            ) : (
              <>
                <Button asChild variant="ghost" className="hidden sm:inline-flex">
                  <Link to="/login">{t("login")}</Link>
                </Button>
                <Button asChild variant="default" className="px-3 sm:px-4">
                  <Link to="/register">{t("register")}</Link>
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
});
